module.exports = __webpack_public_path__ + "img/Cloud-background-right.5fd9fb26.png";